import { FilterTable } from "./filter-table";
export class GroupedFilterTable {
    code: string;
    description: string;
    filters: Array<FilterTable>;

    constructor(code: string, description: string, filters: Array<FilterTable>) {
        this.code = code;
        this.description = description;
        this.filters = filters;
    }
}